<template>
  <div>
    <router-link :to="'post/' + post.slug">
      <div class="home-image-place">
        <div class="home-image bannerAnimation" :style="{ backgroundImage: `url('${post.thumbnail}')` }">
        </div>

        <p v-show="showDetails" class="countAnimation post-count">{{this.romanize(this.postCount)}}</p>
        <div v-show="showDetails" class="post-details latestPostSlide">
          <h2 class="post-title">{{post.title}}</h2>
          <p class="post-description">{{post.description}}</p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "LatestPost",
  props: ['post', 'postCount'],
  data: function () {
    return {
      hoverDetails: false,
      computedHeight: 'auto',
      showDetails: false,
    }
  },
  computed: {
    postDescriptionHeight() {
      if (this.hoverDetails) {
        return { height: `${this.computedHeight}px` }
      } else {
        return { height: 0 }
      }
    },
  },
  methods: {
    initHeight: function(){
      this.$refs['postDescription'].style.position = 'absolute';
      this.$refs['postDescription'].style.visibility = 'hidden';
      this.$refs['postDescription'].style.display = 'block';

      const height = getComputedStyle(this.$refs['postDescription']).height;
      this.computedHeight = height;

      this.$refs['postDescription'].style.position = null;
      this.$refs['postDescription'].style.visibility = null;
      this.$refs['postDescription'].style.display = 'none';
    },
    romanize: function(num) {
      const romanMap = [
        { value: 1000, numeral: 'M' },
        { value: 900, numeral: 'CM' },
        { value: 500, numeral: 'D' },
        { value: 400, numeral: 'CD' },
        { value: 100, numeral: 'C' },
        { value: 90, numeral: 'XC' },
        { value: 50, numeral: 'L' },
        { value: 40, numeral: 'XL' },
        { value: 10, numeral: 'X' },
        { value: 9, numeral: 'IX' },
        { value: 5, numeral: 'V' },
        { value: 4, numeral: 'IV' },
        { value: 1, numeral: 'I' }
      ];

      let roman = '';
      romanMap.forEach(({ value, numeral }) => {
          while (num >= value) {
              roman += numeral;
              num -= value;
          }
      });
      return roman;
    }
  },
  mounted() {
    setTimeout(() => this.showDetails = true, 300)
    this.initHeight();
  }
}
</script>

<style lang="scss" scoped>
  a:link, a:active, a:visited, a:hover {
    text-decoration: none;
  }

  .post-count {
    position: absolute;
    top: 30px;
    right: 60px;
    text-decoration: none;
    font-size: 60px;
    font-weight: lighter;
    text-align: justify;
    color: white;
    margin: 0;
    opacity: 0;

    @media screen and (max-width: 1400px) {
      font-size: 40px;
      top: 20px;
      right: 20px;
    }
  }

    @keyframes countEnter {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .countAnimation {
    animation: countEnter 4s ease-in;
    animation-delay: 0.6s;
    animation-fill-mode: forwards;
  }

  .home-image-place {
    position: relative;
    width: 100%;
    height: 100vh;
    background-color: #161616;
		overflow-x: hidden;
		overflow-y: hidden;
  }

  .home-image {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  .post-details {
    position: absolute;
    top: 58vh;
    left: 5vw;
    padding: 20px 20px;
    .post-title {
      font-size: 80px;
      color: white;
      margin-bottom: 10px;
    }
    .post-description {
      font-size: 24px;
      font-weight: lighter;
      text-align: justify;
      color: white;
      margin: 0;
    }
  }

  @media screen and (max-width: 1400px) {
    .post-details {
      top: 60vh;
      left: 5vw;
      width: 80vw;
      padding: 20px;

      .post-title {
        font-size: 46px;
      }
      .post-description {
        font-size: 24px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .post-details {
      top: 56vh;
      left: 0;
      bottom: 0;
      width: 100vw;
      padding: 40px;

      .post-title {
        font-size: 30px;
      }
      .post-description {
        font-size: 14px;
      }
    }
  }

  @keyframes bannerEnter {
    0% {
      opacity: 0;
      transform: scale(1);
    }
    100% {
      opacity: 1;
      transform: scale(1.08);
    }
  }

  .bannerAnimation {
    animation: bannerEnter 8s ease-out;
    transform: scale(1.08);
  }
</style>

